const optionalPrescriptionProps = ['addition', 'prism', 'prismBase'] as const
const requiredPrescriptionProps = ['sphere', 'cylinder', 'axis', 'pd'] as const
export const prescriptionProps = [
  ...requiredPrescriptionProps,
  ...optionalPrescriptionProps,
] as const
// export type IPrescriptionProp = (typeof prescriptionProps)[number]

export type IPrescriptionProp = (typeof requiredPrescriptionProps)[number]
export type IOptionalPrescriptionProp =
  (typeof optionalPrescriptionProps)[number]

export interface IPrescriptionValue {
  right?: number
  left?: number
}

export type IPrescriptionValues = Record<
  IPrescriptionProp,
  IPrescriptionValue
> &
  Partial<Record<IOptionalPrescriptionProp, IPrescriptionValue>>

export type RxPrescriptionValue = Record<IPrescriptionProp, number> & {
  hpd?: number
  // not 100% correct but otherwise all union type Rx/CL prescription values fail
  addition?: string | number
  prism?: number
  prismBase?: number
}

export const rxProgressiveGlassesPrescriptionConversionType = [
  'distance',
  'reading',
] as const
export type RxProgressiveGlassesPrescriptionConversionType =
  | (typeof rxProgressiveGlassesPrescriptionConversionType)[number]
  | 'progressive'

export interface RxPrescriptionValues {
  type?: RxProgressiveGlassesPrescriptionConversionType
  right: RxPrescriptionValue
  left: RxPrescriptionValue
}

export type RxPrescriptionDisplayValue = Record<IPrescriptionProp, string> &
  Partial<Record<IOptionalPrescriptionProp, string>>

export type RxPrescriptionDisplayValues = {
  left: RxPrescriptionDisplayValue
  right: RxPrescriptionDisplayValue
}

export function isPrescriptionProp(
  prop: any,
): prop is IPrescriptionProp | IOptionalPrescriptionProp {
  return prescriptionProps.includes(prop)
}

export const isRxPrescriptionValue = (
  prescriptionValues: RxPrescriptionValue | ContactLensValue | undefined,
): prescriptionValues is RxPrescriptionValue => {
  return Boolean(prescriptionValues && 'pd' in prescriptionValues)
}

export const isRxPrescriptionValues = (
  prescriptionValues:
    | RxPrescriptionValues
    | Partial<ContactLensValues>
    | undefined,
): prescriptionValues is RxPrescriptionValues => {
  return (
    isRxPrescriptionValue(prescriptionValues?.left) ||
    isRxPrescriptionValue(prescriptionValues?.right)
  )
}
